var textTick = require('../utils').textTick;
var initNoCaptcha = require('../utils').initNoCaptcha;
var auth = require('../auth');
require('./tmpl-renderer');

var VALID_SUCCESS = 'success.valid', VALID_ERROR = 'error.valid', REG_MOBILE = /^1[3-9]\d{9}$/;

$.fn.ycRegisterForm = function (globalOptions) {
    this.each(function () {
        var $form = $(this);
        var $nc = $form.find('[role=yc-nc]');
        var $sendSmsBtn = $form.find('[role="yc-reg-send-sms-btn"]').data('selector', '[role="yc-reg-send-sms-btn"]');
        var $sendSmsRow = $sendSmsBtn.closest('[role=yc-input-row]').hide();
        var $username = $form.find('[name=username]').length ? $form.find('[name=username]') : $form.find('[name=mobile]');
        var smsCaptchaRow = {
            enable: function () {
                $sendSmsRow.show().find('input').prop('disabled', false);
            },
            disable: function () {
                $sendSmsRow.hide().find('input').prop('disabled', true);
            }
        };
        var options = $.extend({
            waitingText: $sendSmsBtn.data('waiting-text') || '等待{sec}秒后再试',
            template: $form.next('script[type="text/x-template"]').length ? $form.next('script[type="text/x-template"]') : null
        }, globalOptions);

        initNoCaptcha($nc, 'register');
        smsCaptchaRow.disable();

        if (options.template) {
            $form.on('success.submit', function () {
                $form.ycTmplRender({template: options.template});
            });
        }

        $form.on('keyup change blur focus', '[name=username]', function () {
            if ($.trim(this.value) != this.value) { //为不影响用户输入光标
                this.value = $.trim(this.value);
            }
        })
            .on('blur', '[name=mobile]', function () {
                var self = $(this);
                var val = self.val();
                if (!val) {
                    self.trigger(VALID_ERROR, ['请输入手机号']);
                    return false;
                }

                if (!REG_MOBILE.test(val)) {
                    self.trigger(VALID_ERROR, ['手机号格式错误，请输入手机号']);
                    return false;
                }

                auth.exists(val, $nc.data('no-captcha')).done(function () {
                    self.trigger(VALID_SUCCESS);
                }).fail(function (rs, msg) {
                    self.trigger(VALID_ERROR, [msg]);
                });
            })
            .on('blur verify', '[name=username]', function () {
                var self = $(this);
                var val = self.val();
                if (!val) {
                    self.trigger(VALID_ERROR, ['请输入手机号或个性账号(6~16位的字母或数字，以字母开头)']);
                    return false;
                }

                // 分析用户预输入
                // 预输入手机号
                if (/^1\d{5,}$/.test(val)) {
                    if (!REG_MOBILE.test(val)) {
                        self.trigger(VALID_ERROR, ['手机号格式错误，请输入手机号或个性账号']);
                        return false;
                    } else {
                        smsCaptchaRow.enable();
                    }
                } else {
                    // 预输个性账号
                    smsCaptchaRow.disable();
                    if (!/^[a-zA-Z][a-zA-Z0-9]{5,15}$/.test(val)) {
                        self.trigger(VALID_ERROR, ['个性账号格式错误，请输入6~16位的字母或数字，以字母开头']);
                        return false;
                    }
                }

                auth.exists(val, $nc.data('no-captcha')).then(function () {
                    self.trigger(VALID_SUCCESS);
                }, function (xhr, msg) {
                    self.trigger(VALID_ERROR, msg);
                });
            })
            .on('blur', '[name=password]', function () {
                var self = $(this);
                var val = this.value;
                var regP = /^[ -~]{8,18}$/;
                var regP2 = /^([ -~])\1{7,}$/;
                var regP3 = /^.{8,18}$/;
                if (!val) {
                    self.trigger(VALID_ERROR, ['密码不能为空']);
                    return;
                }
                if (!regP3.test(val)) {
                    self.trigger(VALID_ERROR, ['密码长度为8-18位']);
                    return;
                }
                if (!regP.test(val)) {
                    self.trigger(VALID_ERROR, ['密码字符有误']);
                    return;
                }
                //同一字符密码返回true
                if (regP2.test(val)) {
                    self.trigger(VALID_ERROR, ['密码不允许为同一字符']);
                    return;
                }

                self.trigger(VALID_SUCCESS);
            })
            .on('blur', '[name=sms_captcha]', function () { //短信验证码
                var self = $(this);
                if (!this.value) {
                    self.trigger(VALID_ERROR, ['请输入短信验证码']);
                    return;
                }

                self.trigger(VALID_SUCCESS);
            })
            .on('click', $sendSmsBtn.data('selector'), function () {
                var self = $(this);
                var waitingText = options.waitingText;
                var defaultText = self.html();
                var username = $username.val();

                self.prop('disabled', true);
                self.text('发送中…');
                auth.sendRegSms(username, $nc.data('no-captcha'))
                    .done(function () {
                        self.trigger('send.success');
                        textTick(self, 60, waitingText, defaultText, function () {
                            self.prop('disabled', false);
                        });

                    }).fail(function (xhr, msg, rs) {
                        textTick(self, 3, '({sec})发送错误:' + rs.ok, defaultText, function () {
                            self.prop('disabled', false);
                        });
                        initNoCaptcha($nc, 'register');
                        self.trigger('send.error', [msg || '服务器繁忙，请稍后再试']);
                    });
            })
            .on('blur', '[name=confirm_password]', function () {
                var self = $(this);
                if (!this.value) {
                    self.trigger(VALID_ERROR, ['请再次输入确认密码']);
                    return false;
                }

                if (this.value !== $form.find('[name=password]').val()) {
                    self.trigger(VALID_ERROR, ['两次输入的密码不一致']);
                    return false;
                }

                self.trigger(VALID_SUCCESS);
            })
            .on('blur', '[name=realname]', function () {
                var self = $(this);
                var val = this.value;
                var regP = /^[\u4e00-\u9fa5]{2,10}$/;
                if (!regP.test(val)) {
                    self.trigger(VALID_ERROR, ['只能输入中文']);
                    return;
                }
                self.trigger(VALID_SUCCESS);
            })
            .on('blur', '[name=idcard]', function () {
                var self = $(this);
                if (!idcardValidator(this.value)) {
                    self.trigger(VALID_ERROR, ['身份证格式错误']);
                    return;
                }
                if (!idcardVerifyAge(this.value)) {
                    self.trigger(VALID_ERROR, ['您的年龄未满18周岁']);
                    return;
                }
                self.trigger(VALID_SUCCESS);
            })
            .on('click blur', 'input[name=agree]', function () {
                var self = $(this);
                if (!this.checked) {
                    var msg = '请确认已查看并同意《服务协议与隐私声明》';
                    self.trigger(VALID_ERROR, [msg]);
                } else {
                    self.trigger(VALID_SUCCESS);
                }
            })
            .on(VALID_ERROR + ' ' + VALID_SUCCESS, 'input', function (e) {
                $(this).data('valid', e.type === 'success');
            })
            .on('submit', function (e) {
                e.preventDefault();
                var $self = $(this), canSubmit = true, self = this, ncResult = $nc.data('no-captcha');
                $self.find('input[name]:enabled').each(function () {
                    var $input = $(this);
                    if ($input.data('valid') === false) {
                        canSubmit = false;
                        this.focus();
                        return false;
                    } else if (!$input.data('valid')) {
                        $input.trigger('blur');
                        canSubmit = $input.data('valid');
                        if (!canSubmit) {
                            this.focus();
                            return false;
                        }
                    }
                });
                var agreed = $self.find('input[name=agree]').prop('checked');
                if (!agreed) {
                    $self.trigger('error.submit', ['请确认已查看并同意《服务协议与隐私声明》']);
                    return;
                }
                if ($.isEmptyObject(ncResult)) {
                    $self.trigger('error.submit', ['请操作滑动验证']);
                    return;
                }

                var username = self.username || self.mobile;
                if (canSubmit) {
                    var defer;

                    if (REG_MOBILE.test(username.value)) { //手机号
                        defer = auth.regMobile(
                            ncResult,
                            username.value,
                            self['sms_captcha'].value,
                            self.password.value,
                            self.realname.value,
                            self.idcard.value
                        );
                    } else {  //个性帐号
                        defer = auth.regUsername(//username, password, realname, idcard, imgCapthca, type, g)
                            ncResult,
                            username.value,
                            self.password.value,
                            self.realname.value,
                            self.idcard.value
                        );
                    }
                    defer.always(function () {
                        //重新生成滑动验证码
                        initNoCaptcha($nc, 'register');

                        //删除defer 对象
                        $self.removeData('yc-defer');
                    });
                    defer.done(function (rs) {
                        $self.trigger('success.submit', rs);
                    }).fail(function (xhr, msg) {
                        $self.trigger('error.submit', [msg, xhr]);
                    });

                    //存储defer，用于其它使用
                    $self.data('yc-defer', defer);
                }
            });
    });
};


/**
 * 身份证验证
 * @param value
 * @returns {boolean}
 */
function idcardValidator(value) {
    var y, l, reg;
    var areas = [11, 12, 13, 14, 15, 21, 22, 23, 31, 32, 33, 34, 35, 36, 37, 41,
        42, 43, 44, 45, 46, 50, 51, 52, 53, 54, 61, 62, 63, 64, 65, 71,
        81, 82, 91];

    if ($.inArray(parseInt(value.substr(0, 2), 10), areas) === -1) {
        return false;
    }

    switch (value.length) {
    case 15:
        y = parseInt(value.substr(6, 2), 10) + 1900;
        l = (y % 4 === 0 || y % 400 === 0) ? 9 : 8;
        reg = '^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-' +
                '9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-' +
                '9]|30)|02(0[1-9]|1[0-9]|2[0-' + l + ']))[0-9]{3}$';
        break;
    case 18:
        y = parseInt(value.substr(6, 4), 10);
        l = (y % 4 === 0 || y % 400 === 0) ? 9 : 8;
        reg = '^[1-9][0-9]{5}(18|19|20)[0-9]{2}((01|03|05|07|08|10|' +
                '12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1' +
                '-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-' + l + ']))[0-9]{3}[0-9Xx' +
                ']$';
        break;
    default:
        return false;
    }
    return (new RegExp(reg)).test(value);
}

/**
 * 身份证年龄验证
 * @param value
 * @returns {boolean}
 */
function idcardVerifyAge(value) {
    var date = value.substr(6, 8);
    date = date.substr(0, 4) + '-' + date.substr(4, 2)  + '-' + date.substr(6, 2);
    date = new Date(date);
    var allowDate = new Date();
    allowDate.setFullYear(allowDate.getFullYear()-18);
    return allowDate > date;
}

$(function () {
    $('form[role~=yc-reg-form]').ycRegisterForm();
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth/src/plugins/register-form.js
// module id = 14
// module chunks = 1